module.exports = __webpack_public_path__ + "media/images/svg-icon/email-a10b44a27ffa1529fc2360f43e98fcaa.svg";